import $ from 'jquery';
import { tns } from 'tiny-slider/src/tiny-slider';

export default class SwipeableContainer {
  init(selector, extraConfig = {}) {
    const viewport_width = document.documentElement.clientWidth || 0;

    const baseConfig = {
      items: viewport_width < 768 ? 1.2 : 2.1,
      center: false,
      speed: 400,
      loop: true,
      gutter: 20,
      edgePadding: 0,
      nav: false,
      controls: false,
      controlsText: ['', ''],
      lazyload: true,
      swipeAngle: 30,
      preventScrollOnTouch: 'auto',
    };

    $(selector).each((i, elm) => {
      const self = $(elm);

      tns({
        ...baseConfig,
        ...extraConfig,
        container: self.find('> div').get(0),

        onInit: evn => {
          const self = $(evn.target);
          let minHeight = 0;
          let images = [];
          let loadCount = 0;

          // Find all images sources
          const imageSrc = self.find('img').map((i, img) => {
            return $(img).attr('src');
          }).get();

          // Add load event each image
          const onImageLoad = () => loadCount += 1;
          const loadImage = src => {
            images.push(new Image());
            images[images.length - 1].src = src;
            images[images.length - 1].onload = onImageLoad;
          };

          const setHeight = () => {
            self.find('.item').each((i, elm) => {
              const colHeight = parseInt($(elm).css('height'), 10);

              if (colHeight > minHeight) {
                minHeight = Math.round(colHeight);
              }
            });

            self.find('.item').each((i, elm) => {
              const currentHeight = parseInt($(elm).css('height'), 10);

              if (currentHeight < minHeight) {
                $(elm).css('height', minHeight);
              }
            });
          };

          const waitForLoaded = () => {
            // When images are loaded we do calculation of height
            if (loadCount === images.length) {
              setHeight();
            } else {
              // All images not loaded wait some more
              setTimeout(waitForLoaded, 100);
            }
          };

          // Start listening for image load
          imageSrc.forEach(loadImage);
          setTimeout(waitForLoaded, 100);
        },
      });
    });
  }
}
